import { selectionStyles, settings } from '@tamagui/config/v5';
import type { CreateTamaguiProps } from 'tamagui';
import { createTamagui } from 'tamagui';
import { animations } from './src/tamagui/animations/animations';
import { fonts } from './src/tamagui/fonts';
import { media } from './src/tamagui/media/media';
import { shorthands } from './src/tamagui/shorthands/shorthands';
import { fontDefaults } from './src/tamagui/themes/font';
import { themes } from './src/tamagui/themes/themes';
import { tokens } from './src/tamagui/tokens';

const config = createTamagui({
  selectionStyles,
  themes,
  tokens,
  shorthands,
  fonts,
  animations,
  media,
  settings: {
    ...settings,
    onlyAllowShorthands: false,
    // TODO: Remove if using server-side rendering
    disableSSR: true
  },
  defaultProps: {
    ...fontDefaults
  }
}) satisfies CreateTamaguiProps;

export default config;

export type Conf = typeof config;
